// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Member names as click-targets + the member detail modal */

.member-name-link {
  color: var(--link-color);
  cursor: pointer;
  text-decoration: none;
}

.member-name-link:hover {
  text-decoration: underline;
}

/* Inside chat bubbles a member @mention keeps the bubble's text color and
   the mention underline; don't recolor it to the generic link blue. */
.member-name-link.chat-mention {
  color: inherit;
}

.member-detail-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 8px;
}

.member-detail-info {
  min-width: 0;
}

.member-detail-message {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  width: auto;
  flex: 0 0 auto;
  margin-top: 0;
}

.member-detail-activity-heading {
  margin: 16px 0 8px;
  font-size: 1rem;
  font-weight: 600;
}

/* Invite autocomplete (team members page + project members modal) */

.member-invite-autocomplete {
  position: relative;
}

.member-invite-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  font-size: 14px;
}

.member-invite-options {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 30;
  background: var(--card-background, var(--background-color));
  border: 1px solid var(--border-color);
  border-radius: 6px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18);
  max-height: 220px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.member-invite-option {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  background: none;
  border: none;
  border-bottom: 1px solid var(--border-color);
  padding: 8px 12px;
  cursor: pointer;
  text-align: left;
  font: inherit;
  color: var(--text-color);
  width: 100%;
  margin: 0;
}

.member-invite-option:last-child {
  border-bottom: none;
}

.member-invite-option:hover,
.member-invite-option-active {
  background: var(--hover-background, rgba(128, 128, 128, 0.12));
}

.member-invite-option-name {
  font-weight: 500;
}

.member-invite-option-hint {
  font-size: 0.85em;
  color: var(--secondary-text-color);
}
`, "",{"version":3,"sources":["webpack://./src/member-details.css"],"names":[],"mappings":"AAAA,4DAA4D;;AAE5D;EACE,wBAAwB;EACxB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;sEACsE;AACtE;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,oEAAoE;;AAEpE;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,2DAA2D;EAC3D,qCAAqC;EACrC,kBAAkB;EAClB,0CAA0C;EAC1C,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,4CAA4C;EAC5C,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,wBAAwB;EACxB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,8DAA8D;AAChE;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;AACpC","sourcesContent":["/* Member names as click-targets + the member detail modal */\n\n.member-name-link {\n  color: var(--link-color);\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.member-name-link:hover {\n  text-decoration: underline;\n}\n\n/* Inside chat bubbles a member @mention keeps the bubble's text color and\n   the mention underline; don't recolor it to the generic link blue. */\n.member-name-link.chat-mention {\n  color: inherit;\n}\n\n.member-detail-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.member-detail-info {\n  min-width: 0;\n}\n\n.member-detail-message {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  width: auto;\n  flex: 0 0 auto;\n  margin-top: 0;\n}\n\n.member-detail-activity-heading {\n  margin: 16px 0 8px;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n/* Invite autocomplete (team members page + project members modal) */\n\n.member-invite-autocomplete {\n  position: relative;\n}\n\n.member-invite-input {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.member-invite-options {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  z-index: 30;\n  background: var(--card-background, var(--background-color));\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18);\n  max-height: 220px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.member-invite-option {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n  background: none;\n  border: none;\n  border-bottom: 1px solid var(--border-color);\n  padding: 8px 12px;\n  cursor: pointer;\n  text-align: left;\n  font: inherit;\n  color: var(--text-color);\n  width: 100%;\n  margin: 0;\n}\n\n.member-invite-option:last-child {\n  border-bottom: none;\n}\n\n.member-invite-option:hover,\n.member-invite-option-active {\n  background: var(--hover-background, rgba(128, 128, 128, 0.12));\n}\n\n.member-invite-option-name {\n  font-weight: 500;\n}\n\n.member-invite-option-hint {\n  font-size: 0.85em;\n  color: var(--secondary-text-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
